import { ChangeDetectorRef, Directive, ElementRef, HostListener, Input } from '@angular/core'

@Directive({ selector: '[isEllipsisActive]' })
export class IsEllipsisActiveDirective {
  @Input() isEllipsisActive!: string

  constructor(
    private elementRef: ElementRef,
    private cdr: ChangeDetectorRef
  ) {}

  @HostListener('mouseenter')
  onMouseEnter(): void {
    const element = this.elementRef.nativeElement
    if (element.offsetWidth < element.scrollWidth || element.offsetHeight < element.scrollHeight) {
      element.title = this.isEllipsisActive || element.innerText
      this.cdr.detectChanges()
    }
  }
}
